import React, { useMemo } from 'react';
import { CircularProgress, Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    root: {
        position: 'relative',
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,

        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',

        backgroundColor: '#fffd',
    },
    loadingIndicator: {
        marginBottom: theme.spacing(2)
    },
    message: {
        textAlign: 'center'
    },
}));

/**
 * @param {Object} props
 * @param {boolean} props.isLoading
 * @param {Partial<ReturnType<useStyles>>} [props.classes]
 */
function OverlayBox(props) {
    const classes = useStyles(props);

    const {
        children,
        isLoading,
        hideLabel,
    } = props;

    const message = useMemo(() => {
        if (isLoading) {
            return Math.random() < 0.001 ? 'Reticulating splines...' : 'Loading...';
        }

        return null;
    }, [isLoading]);

    return (
        <div className={classes.root}>
            {children}

            {isLoading && (
                <div className={classes.overlay}>
                    <CircularProgress className={classes.loadingIndicator} />

                    {!hideLabel && !!message && (
                        <Typography variant='body1' className={classes.message}>
                            {message}
                        </Typography>
                    )}
                </div>
            )}
        </div>
    );
}

export default OverlayBox;